const useLoginTypes = () => {
    return {
        LOGIN: "LOGIN",
        USER_PROGRESS: "USER_PROGRESS"
    };
}

export default useLoginTypes;